import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/core/service/user.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ApiErrorDialogTemplateComponent } from 'src/app/shared/components/dialog-template/api-error-dialog-template/api-error-dialog-template.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  hide = true;


  constructor(private fb: FormBuilder, private userService: UserService, private router: Router, private dialog: MatDialog) {
    this.form = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void { }

  login() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.userService.login(this.form.value).subscribe(x => {
        this.router.navigate(['/']);
      }, error => {

        const dialogRef = this.dialog.open(ApiErrorDialogTemplateComponent, { width: "450px", autoFocus: false, data: error });

      });
    }
  }

  get username() { return this.form.get('username'); }
  get password() { return this.form.get('password'); }

}
